import { AuthAccountContactTypeChoices, useGetProfileCompletionDataLazyQuery } from "@graphql/generated";
import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";

interface UseProfileCompletionDataProps {
  formHandler: UseFormReturn;
}

export const useProfileCompletionData = ({ formHandler }: UseProfileCompletionDataProps) => {
  const [fetchData, { data, loading, error }] = useGetProfileCompletionDataLazyQuery();
  useEffect(() => {
    if (data?.me) {
      const { me } = data;
      const formValues: Record<string, string | string[]> = {};

      if (me.firstName) formValues.firstName = me.firstName;
      if (me.lastName) formValues.lastName = me.lastName;

      if (me.profile?.gender) formValues.gender = me.profile.gender;
      if (me.profile?.industry?.id) formValues.industry = me.profile.industry.id;

      const phoneContact = me.profile?.contacts?.find(
        (contact) => contact?.type === AuthAccountContactTypeChoices.PHONE,
      );
      if (phoneContact?.value) formValues.phone = phoneContact.value;

      if (me.canadaVisa?.nationality?.id) formValues.nationality = me.canadaVisa.nationality.id;
      if (me.canadaVisa?.status) formValues.visaStatus = me.canadaVisa.status;

      formHandler.reset(formValues);
    }
  }, [data, formHandler]);

  return {
    profileData: data?.me,
    isLoading: loading,
    error,
    fetchData,
  };
};

export default useProfileCompletionData;
